export interface MapTheme {
  readonly id: string;
  readonly paper: string;
  readonly paperEdge: string;
  readonly ink: string;
  readonly inkSoft: string;
  readonly edge: string;
  readonly edgeSelected: string;
  readonly edgeHover: string;
  readonly edgeCut: string;
  readonly node: string;
  readonly nodeStroke: string;
  readonly source: string;
  readonly sink: string;
  readonly accent: string;
}

const BASE: Omit<MapTheme, 'id' | 'paper' | 'paperEdge' | 'accent'> = {
  ink: '#2b2118',
  inkSoft: '#7a6a58',
  edge: '#9c8a6a',
  edgeSelected: '#c1121f',
  edgeHover: '#e08a3c',
  edgeCut: '#8d0801',
  node: '#f4e9d8',
  nodeStroke: '#2b2118',
  source: '#2a9d8f',
  sink: '#c1121f',
};

export const THEMES: Record<string, MapTheme> = {
  gearfall: { ...BASE, id: 'gearfall', paper: '#f2e3c9', paperEdge: '#dcc6a0', accent: '#b07d3f' },
  blockade: { ...BASE, id: 'blockade', paper: '#e6eef2', paperEdge: '#c3d5df', accent: '#3d7ea6' },
  coppergrid: {
    ...BASE,
    id: 'coppergrid',
    paper: '#f5e6d3',
    paperEdge: '#d9b892',
    accent: '#b5651d',
  },
  aether: { ...BASE, id: 'aether', paper: '#eae6f5', paperEdge: '#c9c0e0', accent: '#6a4c93' },
  severance: {
    ...BASE,
    id: 'severance',
    paper: '#f0e4e0',
    paperEdge: '#d6b8b0',
    accent: '#9b2226',
  },
  undercity: {
    ...BASE,
    id: 'undercity',
    paper: '#e8e6df',
    paperEdge: '#c4c1b6',
    accent: '#4a5759',
  },
  stronghold: {
    ...BASE,
    id: 'stronghold',
    paper: '#ece4d4',
    paperEdge: '#c8b89a',
    accent: '#5c4033',
  },
};

export function themeFor(themeId: string | undefined): MapTheme {
  return (themeId && THEMES[themeId]) || THEMES.gearfall!;
}
